import SettingsDefaultContainer from "../../container/admin/settings-default";

const SettingsDefault = () => {
    return <SettingsDefaultContainer />;
};

export default SettingsDefault;
